import { Trans } from '@lingui/react/macro'
import { overlay } from '@tecsinapse/cortex-core'
import { Button } from '@tecsinapse/cortex-react'
import React, { useEffect, useState } from 'react'
import { FiDownload } from 'react-icons/fi'
import { IoIosArrowBack, IoIosArrowForward, IoMdClose } from 'react-icons/io'
import { i18n } from '@/i18n'
import { ItemBiblioteca } from '@/core/types/graphql'
import { useDownloads } from '../../../core/hooks/use-downloads'

export const BibliotecaViewSlider = ({
  itens,
  itemSelected,
  onCloseViewItem
}) => {
  const [current, setCurrent] = useState<ItemBiblioteca | null>(null)

  useEffect(() => {
    if (!itemSelected) return setCurrent(null)

    const currentItem = itens.find(item => item.id === itemSelected)
    setCurrent(currentItem || null)
  }, [itens, itemSelected])

  const idx = itens.indexOf(current)
  const hasNext = idx >= 0 && idx < itens.length - 1
  const hasPrev = idx > 0

  const nextSlide = () => hasNext && setCurrent(itens[idx + 1])
  const prevSlide = () => hasPrev && setCurrent(itens[idx - 1])
  const closeSlide = () => {
    setCurrent(null)
    onCloseViewItem()
  }

  const { handleDownload } = useDownloads()

  return (
    <div
      className={overlay({
        show: current !== null,
        className:
          'fixed inset-0 z-[800] flex items-center justify-center bg-black/80'
      })}
      data-testid='file-overlay'
    >
      {current && (
        <>
          <Button
            onClick={prevSlide}
            disabled={!hasPrev}
            className={'absolute top-1/2 left-8 -translate-y-1/2 z-10'}
            size={'square'}
            variants={{
              variant: 'outline'
            }}
          >
            <IoIosArrowBack />
          </Button>
          <Button
            onClick={() => {
              nextSlide()
            }}
            disabled={!hasNext}
            className={'absolute top-1/2 right-8 -translate-y-1/2 z-10'}
            size={'square'}
            variants={{
              variant: 'outline'
            }}
          >
            <IoIosArrowForward />
          </Button>

          <div className='flex flex-col items-center justify-center text-center h-full'>
            <div className='absolute top-4 left-8 right-8 flex items-center gap-4 text-white'>
              <div className={'flex flex-row justify-between w-screen'}>
                <div className={'flex flex-row items-center space-x-deca'}>
                  <Button
                    onClick={closeSlide}
                    variants={{
                      size: 'square',
                      className: 'z-10',
                      variant: 'outline'
                    }}
                    aria-label='Close Slider'
                  >
                    <IoMdClose />
                  </Button>
                  <div className={'text-left'}>
                    <p className='text-h3'>{current.nome}</p>
                    <p>
                      <Trans>Por </Trans>{' '}
                      <strong>{current.proprietario?.nome}</strong>
                    </p>
                    <p>
                      <Trans>Criado em </Trans>{' '}
                      <strong>
                        {i18n.date(current.dataCriacao, { dateStyle: 'short' })}
                      </strong>
                    </p>
                  </div>
                </div>
                <Button
                  variants={{ size: 'square' }}
                  onClick={() =>
                    handleDownload({
                      idArquivo: current.arquivo?.id ?? '',
                      registrarDownload: true
                    })
                  }
                  aria-label='Download File'
                >
                  <FiDownload size={20} />
                </Button>
              </div>
            </div>

            <img
              src={current?.arquivoLink ?? ''}
              alt={current.nome}
              className='max-h-[75vh] rounded-micro'
            />
          </div>
        </>
      )}
    </div>
  )
}
